import StaffActionType from '../actionTypes/StaffActionType';

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case StaffActionType.UPDATE:
      return { ...state, staffUpdated: action.staffUpdated };
    default:
      return state;
  }
};
